/**
 * Internationalization (i18n) module
 * Simple translation system for CRM Meeting Notes
 */

import { pl } from './pl';

// Current language (can be extended to support dynamic language switching)
const currentLanguage = 'pl';

// Available translations
const translations = {
  pl,
};

/**
 * Get translation by key path
 * @param key - Translation key in dot notation (e.g., 'auth.signIn')
 * @returns Translated string
 */
export function t(key: string): string {
  const keys = key.split('.');
  let value: any = translations[currentLanguage];

  for (const k of keys) {
    if (value && typeof value === 'object') {
      value = value[k];
    } else {
      console.warn(`Translation key not found: ${key}`);
      return key;
    }
  }

  return typeof value === 'string' ? value : key;
}

// Export translations for direct access if needed
export { pl };
export default t;
